module.exports = __webpack_public_path__ + "static/media/button_switch.cf031665.svg";